/**
 * TODO: when CPL-23048 is done, only the object will be returned
 * You can verify the returned value in Deezer/deezer > deezer-light.php > function share_getDynamicLink()
 */
export function getUrlFromResult(result: unknown): string | null {
	if (typeof result === 'string') {
		return result;
	}
	if (
		typeof result === 'object' &&
		result !== null &&
		'url' in result &&
		typeof result.url === 'string'
	) {
		return result.url;
	}
	return null;
}
